import { render, staticRenderFns } from "./ReferenceTagSettingsModal.vue?vue&type=template&id=5b5ef355&scoped=true&"
import script from "./ReferenceTagSettingsModal.vue?vue&type=script&lang=js&"
export * from "./ReferenceTagSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceTagSettingsModal.vue?vue&type=style&index=0&id=5b5ef355&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5ef355",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
